// components/SearchInput/index.tsx
import React from "react";
import styles from "./index.module.scss";
import searchIcon from "../../../assets/images/search.svg";
import clearIcon from "../../../assets/images/close-icon.svg";
import { Tooltip } from "@mui/material";

interface SearchInputProps {
  searchText: string;
  searchValue: { open: boolean; value: string };
  setSearchText: (text: string) => void;
  setFinalSearchText: (text: string) => void;
  handleSearch: (query: string) => void;
  setSearchValue: (value: { value: string; open: boolean }) => void;
}

const SearchInput: React.FC<SearchInputProps> = ({
  searchText,
  searchValue,
  setSearchText,
  setFinalSearchText,
  handleSearch,
  setSearchValue,
}) => {
  return (
    <div className={styles.searchContainer}>
      {searchValue.open && (
        <div className={styles.search} data-testid="search-container">
          <input
            type="text"
            className={styles.searchInput}
            autoFocus
            value={searchText}
            placeholder="Search seeker with name"
            onChange={(e) => setSearchText(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearch(e.currentTarget.value);
              }
            }}
            data-testid="search-input"
          />
          {searchText && (
            <button
              className={styles.clearIcon}
              onClick={() => {
                setSearchText("");
                setFinalSearchText("");
              }}
              data-testid="clear-button"
            >
              <img src={clearIcon} alt="clear" data-testid="clear-icon" />
            </button>
          )}
        </div>
      )}
      <Tooltip title="Search" arrow>
        <button className={styles.searchIcon} data-testid="search-button">
          <img
            src={searchIcon}
            alt="search"
            data-testid="search-icon"
            onClick={() =>
              setSearchValue({ value: "", open: !searchValue.open })
            }
          />
        </button>
      </Tooltip>
    </div>
  );
};

export default SearchInput;
